import { render, staticRenderFns } from "./Internship.vue?vue&type=template&id=27760a82&scoped=true&"
import script from "./Internship.vue?vue&type=script&lang=js&"
export * from "./Internship.vue?vue&type=script&lang=js&"
import style0 from "./Internship.vue?vue&type=style&index=0&id=27760a82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27760a82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Coding/farmerspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VCard,VContainer,VFlex,VImg,VLayout,VProgressCircular})
